import { PUSH_NOTIFICATION } from "../types/admin.types";
import { AUTH_SUCCESS } from "../types/admin.types";
import { LOGOUT } from "../types/admin.types";
import { GET_USER_DATA } from "../types/admin.types";

export function login(user) {
  console.log("admin.action login user: ", user);
  return {
    type: AUTH_SUCCESS,
    payload: user
  };
}

export function logout() {
  return {
    type: LOGOUT
  };
}

// export async function getUserData(token) {
//   const res = await fetch(`${server}${usuarios}/admin/me`,
//     { method: 'GET', headers: { 'content-type': 'application/json', 'x-auth-token': token } })
//   const response = await res.json()
//   const user = response.data
//   return {
//     type: GET_USER_DATA,
//     payload: user
//   }
// }

// export async function pushNotification(body) {
//   const res = await fetch(`${server}/admin/push/:rol`,
//     { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) })
//   const admin = await res.json()
//   const payload = admin.data
//   return {
//     type: PUSH_NOTIFICATION,
//     payload
//   }
// }
